import React from 'react'

function Navbar({filterItems, menuList}) {
  return (
    <>
     <nav className='navbar'>
            <div className='btn-group'>

                {
                    menuList.map((curElem) => {
                        return (
                            <button className='btn-group__item'
                            onClick={() => filterItems(curElem)}>{curElem}</button>
                        );
                    })
                }
                
            </div>
        </nav>
    </>
  )
}

export default Navbar
